export const MATOMO_URL = 'https://matomo.betgamestv.it/';
export const PHP_FILENAME = `${MATOMO_URL}matomo.php`;
export const JS_FILENAME = `${MATOMO_URL}matomo.js`;
export const MATOMO_SCRIPT_ID = 'matomo-script';

export const AB_TEST_VARIATIONS = {
    ORIGINAL: 'original',
    VARIATION_1: 'Variation1',
    VARIATION_2: 'Variation2',
    VARIATION_3: 'Variation3',
};

export enum SiteId {
    LOCAL = 16,
    STG = 17,
    PROD = 18,
    DEMO = 20,
}
